import { KojinPrintFormat } from './types'
import { KojinDefaultPrintFormat } from './format/default'

export const KojinPrintFormatList: KojinPrintFormat[] = [
  KojinDefaultPrintFormat
]
